<template>
  <v-navigation-drawer
      v-if="$vuetify.breakpoint.mdAndUp"
      app
      class="text-center"
      color="#181818"
      permanent
  >
    <v-row align="center" class="flex-column fill-height py-5 mx-0" justify="center">
      <router-link to="/">
        <v-img
            contain
            :src="require(`@/assets/logos/logo.svg`)"
            @click="$vuetify.goTo('#hero')"
        />
      </router-link>

      <div class="text-h4 mb-2" v-text="$t('general.name')"/>
      <span
          class="text-h6 primary--text font-weight-light mb-5"
          v-text="$t('general.label')"
      />

      <div v-for="(item, i) in items" :key="i">
        <v-btn
            class="text-capitalize subheading font-weight-light mb-3"
            text
            @click="$vuetify.goTo(item.to)"
        >
          <span v-text="item.name"/>
        </v-btn>
      </div>

      <div class="mt-auto">
        <Social-contacts/>
      </div>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',

  computed: {
    items() {
      return this.$i18n.t('nav-drawer');
    },
  },

  components: {
    SocialContacts: () => import('@/components/SocialContacts'),
  },
};
</script>
